import { html } from "@codemirror/lang-html";
import { useAppDispatch, useAppSelector } from "../../../Redux/store";
import CodeMirror, { ReactCodeMirrorProps, ReactCodeMirrorRef } from '@uiw/react-codemirror';
import { useCallback, useRef, useState } from "react";
import { setCodeSrc } from "../../../Redux/developerSlice";
import { useEvent } from "../../../hooks/event";
import { debounce } from "lodash";


interface IProps {
    className: string;
    codeMirrorProps?: ReactCodeMirrorProps;
}

export const LiveEditor: React.FC<IProps> = ({ className, codeMirrorProps }) => {
    const [maxWidth, setMaxWidth] = useState('100%')
    const { codeSrc } = useAppSelector(state => state.developerSandbox);
    const codeMirrorRef = useRef<ReactCodeMirrorRef>(null);
    const dispatch = useAppDispatch();

    const onChange = useCallback((code: string) => {
        onResize();
        dispatch(setCodeSrc(encodeURIComponent(code)));
    }, []);

    const onResize = () => {
        const containerEl = document.getElementById('codemirror-container');
        if (codeMirrorRef?.current?.editor && containerEl) {
            setMaxWidth(s => {
                const nw = `${containerEl.clientWidth}px`;
                return s !== nw ? s : `${containerEl.clientWidth}px`
            });
        }
    };

    useEvent('resize', debounce(onResize, 100));

    return (
        <CodeMirror
            className={`${className} max-w-[${maxWidth}]`}
            style={{ maxWidth }}
            value={decodeURIComponent(codeSrc)}
            extensions={[html()]}
            onChange={onChange}
            theme="dark"
            height='100%'
            ref={codeMirrorRef}
            {...codeMirrorProps}
        />
    )
}